export default __webpack_public_path__ + "static/media/logo-light.33c12868.png";